import React from 'react';

import {Item} from '@pb/kit-component-group';

import {separator} from './separator.module.styl';

export const Separator = () => {
    return <Item className={separator}/>;
};
